// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"5267": "5d14c54d","7648": "7a1fc96b","8596": "4782e987",}[chunkId] + ".css"
}